$(document).ready(function () {
  $(function () {
    Shopify.itemsToAdd = [];
    Shopify.addItemsToTheCart = function () {
      if (Shopify.itemsToAdd.length) {
        var item = Shopify.itemsToAdd.pop();
        $.ajax({
          url: '/cart/add',
          dataType: 'json',
          type: 'post',
          data: item,
          success: Shopify.addItemsToTheCart,
          error: Shopify.addItemsToTheCart
        });
      }
      else {
        window.location.href = '/cart';
      }
    };

    bindEvents();

    $('.submit-order').on('click', function () {
      $('.p-qty-input').each(function () {
        if ($(this).val() > 0) {
          var prodId = $(this).attr('data-id');
          var prodQty = $(this).val();
          var prod = { quantity: prodQty, id: prodId };
          //console.log(prod);
          Shopify.itemsToAdd.push(prod);
        }
      });
      Shopify.addItemsToTheCart();
    });

    $(".add_more-btn").click(function () {
      var row = $(this).parents('div.product-row');
      var maxRow = $(this).data('max-item');
      var currentID = row.data('id');
      var count = 0;
      $('.product-row').each(function () {
        if ($(this).data('id') == currentID) {
          count++;
        }
      })
      if (count < maxRow) {
        var newIndex = count + 1;
        var newRow = row.clone();
        $('.p-title', newRow).addClass('p-title-child');
        $('.add_more-btn', newRow).remove();
        $('.p-qty-input', newRow).val(0);
        $('.price-display span', newRow).each(function (i, el) {
          var defaultPrice = $(this).data('original-price');
          $(this).text(defaultPrice);
          if (i == 0) {
            $(this).addClass('active-obj');
          } else {
            $(this).removeClass('active-obj');
          }
        });

        row.after(newRow);
        bindEvents();
      }
    });

    tally();
  });

  function bindEvents() {
    $('.p-code .single-option-selector').on('change', function () {
      var val_id = this.value;
      var row = $(this).parents('div.product-row');
      $('.p-price span', row).each(function () {
        $(this).removeClass('active-obj');
        if ($(this).attr('data-id') == val_id) {
          $(this).addClass('active-obj');
        }
      });

      var select_sku = $(this).find('option[value="' + $(this).val() + '"]').data('sku');
      $(this).closest('.product-row').find('.p-var').text(select_sku);

      $('.p-qty .p-qty-input', row).attr('data-id', val_id);
      tally();
    });

    $('.p-qty-input').on('change', function () {
      var row = $(this).parents('div.product-row');
      //tally();
      var qty = parseInt($(this).val());
      $('.p-price span', row).each(function () {

        // BOLD FIX
        var variantId = parseInt(this.getAttribute('data-id'));
        var boldProduct = BOLD.pre.getProductByVariantId(variantId);
        var elem = this;

        if (boldProduct) {
          boldProduct.variants.forEach(function (variant) {
            if (variant.id == variantId) {
              var boldPrice = variant.price;
              elem.setAttribute('data-price', boldPrice);
            }
          });
        }

        var itemPrice = parseInt($(this).attr('data-price'));
        var total = qty * itemPrice;
        var price = '$' + (total / 100).toFixed(2) + ' AUD';
        $(this).text(price);
        //$(this).attr('data-price', total);
      });

      tally();
    });
  }

  function tally() {
    var total = 0;
    $('.price-display').each(function () {
      var itemPrice = parseInt($(this).find('span.active-obj').attr('data-price'));
      var itemQty = parseInt($(this).parent().find('input.p-qty-input').val());
      total += (itemPrice * itemQty)
    });
    var price = '$' + (total / 100).toFixed(2);
    $('.total span').text(price);
  }
});